import { Lab, Week, labs, weeks } from "@/src/lib/content";

export type CourseJourneyItem = {
  kind: "week" | "lab";
  number: number;
  title: string;
  href: string;
  phase: string;
  description: string;
  meta: string;
};

export const labSchedules = [
  { lab: 1, assigned: 3, due: 4 },
  { lab: 2, assigned: 5, due: 6 },
  { lab: 3, assigned: 7, due: 8 },
  { lab: 4, assigned: 9, due: 10 },
  { lab: 5, assigned: 11, due: 12 },
];

function weekItem(week: Week): CourseJourneyItem {
  const meta = week.number === 0
    ? `Pre-course · ${week.phase}`
    : week.number > 12
      ? `Optional extension · ${week.phase}`
      : `Week ${week.number} of 12 · ${week.phase}`;
  return {
    kind: "week",
    number: week.number,
    title: week.title,
    href: `/course/week/${week.slug}`,
    phase: week.phase,
    description: week.narrative,
    meta,
  };
}

function labItem(lab: Lab): CourseJourneyItem {
  const schedule = labSchedules.find((entry) => entry.lab === lab.number)!;
  return {
    kind: "lab",
    number: lab.number,
    title: lab.title,
    href: `/course/lab/${lab.slug}`,
    phase: "Applied lab",
    description: `Assigned Week ${schedule.assigned} · Due Week ${schedule.due}`,
    meta: `Lab ${lab.number} of 5 · Assigned Week ${schedule.assigned} · Due Week ${schedule.due}`,
  };
}

export const courseJourney: CourseJourneyItem[] = weeks.flatMap((week) => {
  const items = [weekItem(week)];
  const schedule = labSchedules.find((entry) => entry.assigned === week.number);
  if (schedule) {
    const lab = labs.find((entry) => entry.number === schedule.lab);
    if (lab) items.push(labItem(lab));
  }
  return items;
});

export function journeyIndexForPath(pathname: string) {
  return courseJourney.findIndex((item) => pathname === item.href || pathname.startsWith(`${item.href}/`));
}

export function relatedLabForWeek(weekNumber: number) {
  const schedule = labSchedules.find((entry) => entry.assigned === weekNumber || entry.due === weekNumber);
  const lab = schedule ? labs.find((entry) => entry.number === schedule.lab) : undefined;
  if (!schedule || !lab) return null;
  return { lab, schedule, relation: schedule.assigned === weekNumber ? "assigned" : "due" } as const;
}

export function weekForNumber(number: number) {
  return weeks.find((week) => week.number === number);
}
